// extracted by mini-css-extract-plugin
export default {"container":"ForgotPasswordPage_container__hn-JR","section_form":"ForgotPasswordPage_section_form__xHsOY","descript":"ForgotPasswordPage_descript__ciTM5"};